import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 待機者ラベル API 操作クラス
 */
export default class WaiterFunctions {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET WaiterLabels
   */
  public async getCounts(userStore: LoginUser, params?: { start?: string; end?: string }): Promise<WaiterFunctionCountsGetModel> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterFunctionCounts, formatParams);
    const response = await this.commonService.executeGet<WaiterFunctionCountsGetModel>(userStore, requestUrl, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);
    return response.data;
  }
}

export interface WaiterFunctionCountsGetModel {
  // key(followers_20230910000000000等)とObjectの組み合わせをAPIから取得する
  [key: string]: WaiterFunctionCountsModel;
}

export interface WaiterFunctionCountsModel {
  /** 施設ID */
  facilityId: number;
  /** ソートキー({type}_{datetime}) */
  waiterFunctionCountsSortKey: string;
  /** 集計種別 */
  type: WaiterFunctionCountType;
  /** 使用回数 */
  count: number;
  /** 日時 */
  datetime: number;
  /** 削除フラグ */
  deleteFlag: boolean;
}

export enum WaiterFunctionCountType {
  /** 待機者数 */
  WAITERS = "waiters",
  /** フォロワー数 */
  FOLLOWERS = "followers",
  /** 募集ページ閲覧数 */
  RECRUITMENT_PV = "recruitmentPv",
  /** お問い合わせ数 */
  CONTACT_CV = "contactCv",
  /** 施設見学申込み数 */
  FACILITY_TOUR_CV = "facilityTourCv",
  /** フォロワー登録数 */
  FOLLOWER_CV = "followerCv",
  /** 入所申込みページ閲覧数 */
  ADMISSION_PV = "admissionPv",
  /** 入所申込数(本人) */
  ADMISSION_USER_CV = "admissionUserCv",
  /** 入所申込数(施設) */
  ADMISSION_FACILITY_CV = "admissionFacilityCv"
}
